import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withCookies } from 'react-cookie';
import { Buffer } from 'buffer';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import Common from '../Common';
import isEmpty from 'lodash.isempty';

const useStyles = theme => ({
    root: {
        margin: "10px",
        height: "85vh",
        backgroundColor: "#63A8DD",
    },
    paper: {
        padding: theme.spacing(5),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        margin: "0 auto",
        width: "50%",
        top: "90px",
        position: "relative",
    },
    project_name:{
        textAlign: "center",
        top: "40px",
        position: "relative",
        //fontSize: "2em",
        color: "white"
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing() * 1,
    },
    submit: {
        marginTop: theme.spacing() * 2,
    },
    error_message:{
        fontSize:"18px"
    }
});

class Signin extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loginFlg: false,
            staffNumber: '',
            authenticationCode: '',
            message: ''
        }
        this.refreshAzureTokenIntervalId = "";
        this.onLogin = this.onLogin.bind(this)
    }

    staffNumberHandleChange = event => {
        this.setState({
            staffNumber: event.target.value
        });
    };

    authenticationCodeHandleChange = event => {
        this.setState({
            authenticationCode: event.target.value
        });
    };

    //Reactのログイン完了後フロントの設定値取得
    getReactSetting = () => {
        try{
            const { cookies } = this.props;
            const accessToken = cookies.get('access_token');
            const token = cookies.get('token');
            const id_token = cookies.get('id_token');
            const userData = this.getb2cInfo(id_token);
            const oid = userData.oid;
            axios.get(`${Common.apiServerUrl()}/api/supporter`,
            {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + accessToken,
                    'x-suppportcenter-token': token
                },
                params:{
                    params: oid || '',
                },
            })
            .then(Common.handleErrors)
            .then((ReactSettingResponse) => {
                cookies.set('AVAILABLE_ADDRESS', ReactSettingResponse.addressFlg, {
                    maxAge: 60 * 60 * 24 * 1, //1日間
                    httpOnly: false,
                    path: '/',
                    secure: true,
                });
                cookies.set('COMMON_NAME_OBJ', JSON.stringify(ReactSettingResponse.commonNameObj), {
                    maxAge: 60 * 60 * 24 * 1, //1日間
                    httpOnly: false,
                    path: '/',
                    secure: true,
                });
                cookies.set('PRINT_NAME_OBJ', JSON.stringify(ReactSettingResponse.printNameObj), {
                    maxAge: 60 * 60 * 24 * 1, //1日間
                    httpOnly: false,
                    path: '/',
                    secure: true,
                });
                cookies.set('CREATE_CATEGROY_NAME_OBJ', JSON.stringify(ReactSettingResponse.createCategoryNameObj), {
                    maxAge: 60 * 60 * 24 * 1, //1日間
                    httpOnly: false,
                    path: '/',
                    secure: true,
                });
            })
            .catch((err) =>{
                console.error('SignIn.js reactSetting:get err:' + err.message);
            });
        }
        catch(err){
            console.log(err);
        }
    }

    onLogin() {
        const { cookies } = this.props;
        const accessToken = cookies.get('access_token');
        const token = cookies.get('token');
        const id_token = cookies.get('id_token');
        const userData = this.getb2cInfo(id_token);
        const oid = userData.oid;
        //----------------------------
        // ログイン処理
        //----------------------------
        axios.post(
            `${Common.apiServerUrl()}/api/supporter/login`,
            {
                userIdLogin: this.state.staffNumber,
                password: this.state.authenticationCode,
                oid: oid || '',
            },
            {
                headers: {
                    'Authorization': 'Bearer ' + accessToken,
                    'x-suppportcenter-token': token
                },
                // mode: 'cors',
                // credentials: 'include', //クレデンシャルを含める指定
            }
        )
        .then(Common.handleErrors)
        .then(loginResponse => {
            //successはbool型
            if (loginResponse.success) {
                console.log(loginResponse);
                cookies.set('supportedPersonId', loginResponse.supportedPersonId);
                cookies.set('supporterFullName', loginResponse.fullName);
                cookies.set('x-jichitai-jichitaiid', loginResponse.jichitaiId, {
                    maxAge: 60 * 60 * 24 * 1, //1日間
                    httpOnly: false,
                    path: '/',
                    secure: true,
                });
                cookies.set('x-jichitai-token', loginResponse.jichitaiToken, {
                    maxAge: 60 * 60 * 24 * 1, //1日間
                    httpOnly: false,
                    path: '/',
                    secure: true,
                });
                cookies.set('allSupportedPersonGet', loginResponse.allSupportedPersonGetFlag, {
                    maxAge: 60 * 60 * 24 * 1, //1日間
                    httpOnly: false,
                    path: '/',
                    secure: true,
                });
                cookies.set('AVAILABLE_CREATE_KUBUN', loginResponse.createFlg, {
                    maxAge: 60 * 60 * 24 * 1, //1日間
                    httpOnly: false,
                    path: '/',
                    secure: true,
                });
                //通報機能を利用している場合
                cookies.set('AVAILABLE_SUPPONET', loginResponse.availableSupponet, {
                    maxAge: 60 * 60 * 24 * 1, //1日間
                    httpOnly: false,
                    path: '/',
                    secure: true,
                });
                window.location.href = '/chat';
            } else {
                this.setState({
                    message: '職員番号または認証コードが間違っています。'
                });
            }
        })
        .catch(err => {
            // alert("error");
            console.log(err);
            if (Object.keys(err).indexOf('data') !== -1) {
                alert(`code : [${err.code}]\nmessage : ${err.error_usermsg}`);
            } else {
                alert(err);
                alert(`code : [onLogin]]\nmessage : エラーが発生しました。サポートに連絡してください。`);
            }
        })
    }

    getb2cInfo(token) {
        const baseArray = token.split('.');
        const userData = JSON.parse(Buffer.from(baseArray[1].replace(/-/g, '+').replace(/_/g, '/'), 'base64').toString());
        return userData;
    }

    //-----------------------------------------------------------------
    //Azure AD 認証
    //-----------------------------------------------------------------
    getData() {
        const { cookies } = this.props;
        const id_token = cookies.get('id_token');
        if(id_token === undefined && !window.location.hash.match('#id_token=')){
            window.location.href = process.env.REACT_APP_AUTH_URL;
        }
        else{
            if(id_token !== undefined && !window.location.hash.match('#id_token=')){
                const token = id_token;
                //b2cログイン情報取得
                const userData = this.getb2cInfo(token);
                //UNIXを一般的な時間しトークンの有効期限を取得
                const expDate = new Date(userData.exp * 1000);
                const now = new Date();
                //現在の時間が有効期限を過ぎていたらログイン画面を表示
                if(expDate <= now){
                    window.location.href = process.env.REACT_APP_AUTH_URL;
                }
            }
            if(window.location.hash.match('#id_token=')){
                cookies.set('id_token', window.location.hash.replace('#id_token=',''), {
                    maxAge: 60 * 60 * 24 * 1, //1日間
                    httpOnly: false,
                    path: '/',
                    secure: true,
                });
            }
            this.getData_();
        }
    }



    getData_ = () => {
        const { cookies } = this.props;
        const idToken = cookies.get('id_token');
        //----------------------------
        //トークンを取得
        //----------------------------
        axios.post(
            `${Common.apiServerUrl()}/api/auth/token`,
            {},
            {
                headers: {
                    'Authorization': 'Bearer ' + idToken
                },
                // mode: 'cors',
                // credentials: 'include', //クレデンシャルを含める指定
            }
        )
        .then(Common.handleErrors)
        .then(tokenResponse => {
            //
            if (tokenResponse.success) {
                //----------------------------
                // AzureAD　トークンの更新処理
                //----------------------------
                //テスト時5分ごとにAzureADTokenをリフレッシュ(本来50分くらい※トークンの有効期限は1時間);
                // this.refreshAzureTokenIntervalId = setInterval(this.refreshAzureToken, 300000);


                //tokenをセット
                cookies.set('token', tokenResponse.token);
                this.getReactSetting();
            }
        })
        .catch(err => {
            // alert(`code:${err.code} ${err.error_usermsg}`);
            // alert('getData_失敗');
            console.log("getData_ERROR");
            alert(`code : [getData_]]\nmessage : エラーが発生しました。サポートに連絡してください。`);
            //----------------------------
            // AzureAD　トークンの更新処理
            //----------------------------
            // console.log(err);
            // console.log(err.response);
            // console.log(err.response.status);
            // //tokenがない場合
            // if(err.response.status === 401){
            //     this.refreshAzureToken();
            // }
        })
    }


    //-----------------------------------------------------------------
    // コンポーネントがマウントされた直後に実行
    //-----------------------------------------------------------------
    componentDidMount() {
        const { cookies } = this.props;
        cookies.remove('supportedPersonId');//対応者IDを削除
        cookies.remove('supporterFullName');//対応者名を削除
        document.title = 'ログイン'

        // データ取得
        this.getData();
    }

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>
                <CssBaseline />
                <div>
                    <Typography variant="h4" className={classes.project_name}>
                        {"ログイン"}
                    </Typography>

                    <Paper className={classes.paper}>
                        <Typography color="error" align="center" className={classes.error_message}>
                            {this.state.message}
                        </Typography>
                        <form className={classes.form} noValidate>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                id="staffNumber"
                                label="職員番号"
                                name="staffNumber"
                                autoComplete="staffNumber"
                                onChange={this.staffNumberHandleChange}
                                value={this.state.staffNumber}
                                autoFocus
                            />
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                fullWidth
                                name="authenticationCode"
                                label="認証コード"
                                type="password"
                                id="authenticationCode"
                                onChange={this.authenticationCodeHandleChange}
                                value={this.state.authenticationCode}
                                autoComplete="current-password"
                            />
                            <Button
                                //type="submit"
                                align="center"
                                variant="contained"
                                fullWidth
                                color="primary"

                                className={classes.submit}
                                onClick={this.onLogin}
                            >
                                ログイン{}
                            </Button>
                        </form>
                    </Paper>
                </div>
            </div>
        );
    }
}

export default withCookies(withStyles(useStyles)(Signin));